import { useState } from "react";
import { Card, Box, Typography, IconButton, Divider } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

// Reusable component for each data row
const DataItem = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mt={1}>
    <Typography variant="body2" color="textSecondary">{label}</Typography>
    <Typography variant="body2">{value || "N/A"}</Typography>
  </Box>
);

const DeviceCard = ({ deviceData }) => {
  const devices = deviceData?.devices || [];
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const currentDevice = devices[currentIndex];

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < devices.length - 1) setCurrentIndex(currentIndex + 1);
  };

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "10px",
        boxShadow: 3,
        padding: "1rem",
        textAlign: currentDevice ? "left" : "center",
      }}
    >
      {/* No devices case */}
      {!currentDevice ? (
        <Typography variant="h6" fontWeight="bold" color="error">
          No Device Connected
        </Typography>
      ) : (
        <>
          {/* Header Section */}
          <Box display="flex" alignItems="center">
            <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
              <ArrowBack />
            </IconButton>

            <Box ml={2} flexGrow={1}>
              <Typography variant="h6" fontWeight="bold">My Devices</Typography>
              <Box display="flex" alignItems="center">
                <Typography
                  variant="body2"
                  color={currentDevice.status === "active" ? "green" : "red"}
                >
                  {currentDevice.status === "active" ? "Active" : "Inactive"}
                </Typography>
              </Box>
            </Box>

            <IconButton onClick={handleNext} disabled={currentIndex === devices.length - 1}>
              <ArrowForward />
            </IconButton>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Device Data Section */}
          <Box mt={2}>
            {/* <DataItem label="ID" value={currentDevice.id} /> */}
            <DataItem label="Device Type" value={currentDevice.deviceType} />
            <DataItem label="Device Model" value={currentDevice.deviceModel} />
            <DataItem label="IMEI" value={currentDevice.deviceImei} />
            {/* <DataItem label="Assigned To" value={currentDevice.assignedTo} /> */}
            <DataItem label="Malfunctioned" value={currentDevice.malfunctioned ? "Yes" : "No"} />
          </Box>

          {/* Device Index Indicator */}
          <Box mt={2} textAlign="center">
            <Typography variant="body2">
              Device {currentIndex + 1} of {devices.length}
            </Typography>
          </Box>
        </>
      )}
    </Card>
  );
};

export default DeviceCard;
